export const ChevronRightIcon = ({
  fill = 'none',
  width = '36',
  height = '36',
  viewBox = '0 0 36 36',
  ...rest
}: React.SVGProps<SVGSVGElement>) => (
  <svg width={width} height={height} viewBox={viewBox} fill={fill} xmlns="http://www.w3.org/2000/svg" {...rest}>
    <g id="Icon container">
      <circle id="Ellipse 20" cx="18" cy="18" r="17.5" transform="rotate(180 18 18)" fill="white" stroke="#DEDEE0" />
      <path
        id="Vector"
        d="M16.1115 11.3887L22.7227 17.9998L16.1115 24.6109"
        stroke="#373D40"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
)
